import React from "react";

import { EssayID } from "./essayMetadata";

const essayMetaTags: Record<EssayID, () => React.ReactElement<any>[]> = {
  qcvc: () => [
    <meta
      name="citation_title"
      content="Quantum computing for the very curious"
    />,
    <meta
      name="Description"
      content="Introduction to the core principles of quantum computation"
    />,
    <meta name="citation_author" content="Matuschak, Andy" />,
    <meta name="citation_author" content="Nielsen, Michael" />,
    <meta name="citation_publication_date" content="2019" />,
    <meta
      name="citation_fulltext_html_url"
      content="https://quantum.country/qcvc"
    />,
    <meta name="citation_fulltext_world_readable" content="" />,

    <meta property="og:url" content="https://quantum.country/qcvc" />,
    <meta property="og:type" content="article" />,
    <meta
      property="og:title"
      content="Quantum computing for the very curious"
    />,
    <meta
      property="og:description"
      content="Presented in an experimental mnemonic medium that makes it almost effortless to remember what you read"
    />,
    <meta
      property="og:image"
      content="https://quantum.country/assets/social.png"
    />,
    <meta property="og:image:alt" content="A simple quantum circuit" />,
    <meta property="og:site_name" content="Quantum Country" />,
    <meta property="og:image:type" content="image/png" />,
    <meta property="og:image:width" content="1600" />,
    <meta property="og:image:height" content="800" />,
    <meta name="twitter:card" content="summary_large_image" />,
    <meta
      name="twitter:title"
      content="Quantum computing for the very curious"
    />,
    <meta
      name="twitter:image"
      content="https://quantum.country/assets/social.png"
    />,
    <meta name="twitter:image:alt" content="A simple quantum circuit" />,
    <meta
      name="twitter:description"
      content="Presented in an experimental mnemonic medium which makes it almost effortless to remember what you read"
    />,
  ],

  search: () => [
    <meta
      name="Description"
      content="Explains the quantum search algorithm and introduces the design of quantum algorithms"
    />,
    <meta
      name="citation_title"
      content="How the quantum search algorithm works"
    />,
    <meta name="citation_author" content="Matuschak, Andy" />,
    <meta name="citation_author" content="Nielsen, Michael" />,
    <meta name="citation_publication_date" content="2019" />,
    <meta
      name="citation_fulltext_html_url"
      content="https://quantum.country/search"
    />,
    <meta name="citation_fulltext_world_readable" content="" />,

    <meta property="og:url" content="https://quantum.country/search" />,
    <meta property="og:type" content="article" />,
    <meta
      property="og:title"
      content="How the quantum search algorithm works"
    />,
    <meta
      property="og:description"
      content="An explanation of how the quantum search algorithm works, & introduction to the design of quantum algorithms"
    />,
    <meta
      property="og:image"
      content="https://quantum.country/assets2/social.png"
    />,
    <meta
      property="og:image:alt"
      content="Circuit for the quantum search algorithm"
    />,
    <meta property="og:site_name" content="Quantum Country" />,
    <meta property="og:image:type" content="image/png" />,
    <meta property="og:image:width" content="1600" />,
    <meta property="og:image:height" content="800" />,
    <meta name="twitter:card" content="summary_large_image" />,
    <meta
      name="twitter:title"
      content="How the quantum search algorithm works"
    />,
    <meta
      name="twitter:image"
      content="https://quantum.country/assets2/social.png"
    />,
    <meta
      name="twitter:image:alt"
      content="Circuit for the quantum search algorithm"
    />,
    <meta
      name="twitter:description"
      content="An explanation of how the quantum search algorithm works, & introduction to the design of quantum algorithms"
    />,
  ],

  teleportation: () => [
    <meta
      name="Description"
      content="How quantum teleportation works and why it matters"
    />,
    <meta name="citation_title" content="How quantum teleportation works" />,
    <meta name="citation_author" content="Matuschak, Andy" />,
    <meta name="citation_author" content="Nielsen, Michael" />,
    <meta name="citation_publication_date" content="2019" />,
    <meta
      name="citation_fulltext_html_url"
      content="https://quantum.country/teleportation"
    />,
    <meta name="citation_fulltext_world_readable" content="" />,

    <meta property="og:url" content="https://quantum.country/teleportation" />,
    <meta property="og:type" content="article" />,
    <meta property="og:title" content="How quantum teleportation works" />,
    <meta
      property="og:description"
      content="An explanation of how quantum teleportation works, and why it matters"
    />,
    <meta
      property="og:image"
      content="https://quantum.country/assets3/social.png"
    />,
    <meta property="og:image:alt" content="Quantum Country logo" />,
    <meta property="og:site_name" content="Quantum Country" />,
    <meta property="og:image:type" content="image/png" />,
    <meta property="og:image:width" content="1600" />,
    <meta property="og:image:height" content="800" />,
    <meta name="twitter:card" content="summary_large_image" />,
    <meta name="twitter:title" content="How quantum teleportation works" />,
    <meta
      name="twitter:image"
      content="https://quantum.country/assets3/social.png"
    />,
    <meta name="twitter:image:alt" content="Quantum Country logo" />,
    <meta
      name="twitter:description"
      content="An explanation of how quantum teleportation works, and why it matters"
    />,
  ],

  qm: () => [
    <meta
      name="Description"
      content="Explains the core principles of quantum mechanics and their startling implications"
    />,
    <meta name="citation_title" content="Quantum mechanics distilled" />,
    <meta name="citation_author" content="Matuschak, Andy" />,
    <meta name="citation_author" content="Nielsen, Michael" />,
    <meta name="citation_publication_date" content="2019" />,
    <meta
      name="citation_fulltext_html_url"
      content="https://quantum.country/qm"
    />,
    <meta name="citation_fulltext_world_readable" content="" />,

    <meta property="og:url" content="https://quantum.country/qm" />,
    <meta property="og:type" content="article" />,
    <meta property="og:title" content="Quantum mechanics distilled" />,
    <meta
      property="og:description"
      content="A detailed explanation of the core principles of quantum mechanics, and their startling implications"
    />,
    <meta
      property="og:image"
      content="https://quantum.country/assets4/social.png"
    />,
    <meta property="og:image:alt" content="Quantum Country logo" />,
    <meta property="og:site_name" content="Quantum Country" />,
    <meta property="og:image:type" content="image/png" />,
    <meta property="og:image:width" content="1600" />,
    <meta property="og:image:height" content="800" />,
    <meta name="twitter:card" content="summary_large_image" />,
    <meta name="twitter:title" content="Quantum mechanics distilled" />,
    <meta
      name="twitter:image"
      content="https://quantum.country/assets4/social.png"
    />,
    <meta name="twitter:image:alt" content="Quantum Country logo" />,
    <meta
      name="twitter:description"
      content="A detailed explanation of the core principles of quantum mechanics, and their startling implications"
    />,
  ],
};

export default essayMetaTags;
